<template>
  <!-- 支付成功之后的回调页面 -->
  <div id="orderPay">
    <div class="box">
      <div v-if="userId">
        <p style="color: #333; margin-bottom: 20px">请确认微信支付是否已完成</p>
        <p>
          <van-button
            type="primary"
            size="small"
            @click="confirmBtn"
            style="margin-right: 10px"
            >已完成支付</van-button
          >
          <van-button type="danger" size="small" @click="confirmBtn"
            >未完成支付</van-button
          >
        </p>
      </div>
      <div v-else>
        <p style="color: #333; margin-bottom: 30px">
          请切换到已登录的浏览器或重新登录
        </p>
        <van-button
          type="primary"
          @click="confirmBtn1"
          style="width: 120px; height: 40px"
          >确定</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    userId() {
      return this.$store.state.user.userId;
    },
  },
  methods: {
    confirmBtn() {
      // this.getPremission();
      this.$router.push("onlineMall");
    },
    confirmBtn1() {
      this.$router.replace("index");
    },
  },
};
</script>

<style lang="less" scoped>
#orderPay {
  color: red;
  width: 100%;
  height: 100%;
  .box {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
}
</style>
